function getTabs(tabGroupId) {
  return Array.from(document.querySelectorAll("[id=\"" + tabGroupId + "\"] [role=\"tab\"]:not(:disabled)")).map(function (tab) {
    return tab.getAttribute('data-tab-id');
  });
}

export { getTabs };
